import { TransportDetailsPanel } from "./TransportDetailsPanel/TransportDetailsPanel"
import { ShipmentPanelList } from "./ShipmentPanelList/ShipmentPanelList"

export const FreightPaymentDetailsInput = () => {
    return <div>
        <TransportDetailsPanel/>
        <ShipmentPanelList/>
    </div>
}
